<template>
  <v-app>
    <!-- Hero Section -->
    <section class="hero-section">
      <v-container>
        <v-row align="center" justify="center" class="fill-height">
          <v-col cols="12" md="8" class="text-center">
            <h1 class="display-1 font-weight-bold white--text mb-4">
              Centro Médico Terrada
            </h1>
            <p class="headline white--text mb-6">
              Atención médica integral de calidad en Bahía Blanca
            </p>
            <p class="title white--text mb-8">
              Contamos con profesionales altamente especializados para brindarle la mejor atención médica
            </p>
            <v-btn 
              x-large 
              color="white" 
              class="primary--text mr-4 mb-4"
              @click="redirectToAppointment"
              elevation="3"
            >
              <v-icon left>mdi-calendar-plus</v-icon>
              Sacar Turno
            </v-btn>
            <v-btn 
              x-large 
              outlined 
              color="white" 
              class="mb-4"
              @click="redirectToAbout"
            >
              <v-icon left>mdi-information</v-icon>
              Conocer Más
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Services Section -->
    <section class="services-section py-12">
      <v-container>
        <v-row>
          <v-col cols="12" class="text-center mb-8">
            <h2 class="display-1 font-weight-bold primary--text mb-4">
              Nuestros Servicios
            </h2>
            <p class="title grey--text text--darken-2">
              Especialidades médicas para toda la familia
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            v-for="service in featuredServices" 
            :key="service.title"
            cols="12" 
            sm="6" 
            md="4"
            class="mb-4"
          >
            <v-card 
              class="h-100 service-card" 
              elevation="3"
              @click="redirectToAppointment"
              style="cursor: pointer;"
            >
              <v-card-text class="text-center pa-6">
                <v-icon 
                  :color="service.color" 
                  size="48" 
                  class="mb-4"
                >
                  {{ service.icon }}
                </v-icon>
                <h3 class="headline font-weight-bold mb-3">{{ service.title }}</h3>
                <p class="body-1 grey--text text--darken-1">{{ service.description }}</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Quick Info Section -->
    <section class="quick-info-section primary lighten-5 py-8">
      <v-container>
        <v-row>
          <v-col cols="12" md="4" class="text-center mb-4">
            <v-icon color="primary" size="48" class="mb-3">mdi-clock-outline</v-icon>
            <h3 class="title font-weight-bold mb-2">Horarios</h3>
            <p class="body-1">Lunes a Viernes: 8:00 - 20:00</p>
            <p class="body-1">Sábados: 9:00 - 13:00</p>
          </v-col>
          <v-col cols="12" md="4" class="text-center mb-4">
            <v-icon color="primary" size="48" class="mb-3">mdi-phone</v-icon>
            <h3 class="title font-weight-bold mb-2">Contacto</h3>
            <p class="body-1">📞 {{ contactInfo.PHONE.DISPLAY }}</p>
            <p class="body-1">📱 WhatsApp: {{ contactInfo.WHATSAPP.DISPLAY }}</p>
          </v-col>
          <v-col cols="12" md="4" class="text-center mb-4">
            <v-icon color="primary" size="48" class="mb-3">mdi-map-marker</v-icon>
            <h3 class="title font-weight-bold mb-2">Ubicación</h3>
            <p class="body-1">{{ contactInfo.ADDRESS }}</p>
            <p class="body-1">Bahía Blanca, Buenos Aires</p>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Our Medical Team Section -->
    <section class="doctors-section py-12">
      <v-container>
        <v-row>
          <v-col cols="12" class="text-center mb-8">
            <h2 class="display-1 font-weight-bold primary--text mb-4">
              Nuestro Equipo Médico
            </h2>
            <p class="title grey--text text--darken-2">
              Profesionales especializados para su bienestar
            </p>
          </v-col>
        </v-row>
        
        <!-- Featured Doctors -->
        <v-row>
          <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards 
              nombre="Dra. Mariana Argumedo" 
              espcialidad="Médica UNR - Especialista en Psiquiatría" 
              descripcion="Especialista en Psiquiatría y Psicología médica. Médica del Servicio de Salud Mental H.I.G Dr José Penna."
              :image="image7"
            />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards 
              nombre="Dr. Mauricio Moris" 
              espcialidad="Médico UNLP - Especialista en Neurología" 
              descripcion="Atención de patologías neurológicas: Parkinson, Demencias, Epilepsia, Cefaleas, Trastornos de sueño, ACV."
              :image="image10"
            />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards 
              nombre="Dra. Agustina Revelant" 
              espcialidad="Especialista en Cirugía Plástica (UBA)" 
              descripcion="Miembro de SACPER, Miembro de la Sociedad de Cirugía Plástica de la Patagonia"
              :image="image1"
            />
          </v-col>
        </v-row>

        <!-- More Doctors -->
        <v-row>
          <!-- <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards 
              nombre="Dra. Noelani Colinas"
              espcialidad="Especialista en Ginecología y Obstetricia"
              descripcion="Médica Especialista Jerarquizada en Ginecología y Obstetricia"
              :image="image11"
            />
          </v-col> -->
          <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards
              nombre="Dr. Ramiro Kornsusky"
              espcialidad="Especialista en Nefrologia y Diabetes"
              descripcion="Atención de patologías renales y diabetes."
              :image="image23"
            />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards 
              nombre="Dr. Marcelo Prada" 
              espcialidad="Especialista en Clínica Médica UNLP" 
              descripcion="Especialista en Nutrición con Orientación en Obesidad. Jefe de Sala Baja Complejidad H.I.G Dr. José Penna"
              :image="image2"
            />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards 
              nombre="Dra. Agustina D'Amico" 
              espcialidad="Especialista en Reumatología" 
              descripcion="Especialista Jerarquizada en Reumatología. Formación Hospital Británico de Bs As, UBA. Miembro SAR"
              :image="image5"
            />
          </v-col>
        </v-row>

        <!-- Additional Doctors Row -->
        <v-row>
          <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards 
              nombre="Dr. Martin Merli" 
              espcialidad="Especialista en Cirugía General UNLP" 
              descripcion="Staff del Servicio de Cirugía H.I.G Dr José Penna. Cirugía laparoscópica y de paredes abdominales"
              :image="image8"
            />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards 
              nombre="Dra. Maria de los Angeles Terragnolo"
              espcialidad="Medica clínica especializada en diabetes"
              descripcion="Especialista en diabetes y enfermedades metabólicas. Atención integral del paciente diabético."
              :image="image21"
            />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards
              nombre="Dr. Juan Manuel Herrero"
              espcialidad="Especialista en Neurocirugía"
              descripcion="Formación Hospital Nacional Prof. A. Posadas. Neurocirugía de adultos y pediátrica. Cirugía de columna"
              :image="image6"
            />
          </v-col>
        </v-row>

        <!-- Final Doctors Row -->
        <v-row>
          <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards 
              nombre="Dr. Matias Valdemoros" 
              espcialidad="Especialista en Cardiología UBA/SAC" 
              descripcion="Miembro de la Sociedad Argentina de Cardiología. Especialista en Ecocardiografía Doppler"
              :image="image9"
            />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards 
              nombre="Dra. Rosana Tupone" 
              espcialidad="Especialista en Dermatología" 
              descripcion="Estética, Peeling, Botox, Ácido hialurónico"
              :image="image13"
            />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards 
              nombre="Dr. Alejandro Griglio" 
              espcialidad="Especialista en Ortopedia y Traumatología" 
              descripcion="Consultas en miembro inferior, cadera, rodilla, tobillo y pie"
              :image="image16"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards 
              nombre="Dr. Jorge Bettini"
              espcialidad="Especialista Jerarquizado en Neumología"
              descripcion="Jefe de Unidad de Neumología del HMALL. Miembro AAMR. Estudios funcionales respiratorios y del sueño"
              :image="image19"
            />
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards
              nombre="Dr. Silvina De Pedro"
              espcialidad="Especialista Consultora en Endocrinologia"
              descripcion="Atención de patologías endocrinológicas: Diabetes, Tiroides, Metabolismo óseo, Hipófisis y Suprarrenales"
              :image="image22"
            />
          </v-col>
           <v-col cols="12" md="6" lg="4" class="mb-6">
            <cards
              nombre="Dr. Nicolas Dosso"
              espcialidad="Especialista en cirugía vascular"
              descripcion="Tratamiento de patologías arteriales y venosas. Ecografía Doppler vascular"
              :image="image24"
            />
          </v-col>
        </v-row>

        <!-- Call to Action -->
        <v-row class="mt-8">
          <v-col cols="12" class="text-center">
            <v-btn 
              x-large 
              color="primary" 
              @click="redirectToAppointment"
              elevation="3"
            >
              <v-icon left>mdi-calendar-plus</v-icon>
              Reservar Consulta
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </section>

  </v-app>
</template>

<script>
import revelant from "../assets/img/agustinarevelant.jpeg"
import prada from "../assets/img/marceloprada.jpeg"
import damico from "../assets/img/agustinadamico.jpeg"
import herrero from "../assets/img/juanmherrero.jpeg"
import argumedo from "../assets/img/marianaargumedo.jpeg"
import merli from "../assets/img/martinmerli.jpeg"
import valdemoros from "../assets/img/matiasvaldemoros.jpeg"
import moris from "../assets/img/mauriciomoris.jpeg"
//import colinas from "../assets/img/noelanicolinas.jpeg"
import tupone from "../assets/img/rosanatupone.jpeg"
import griglio from "../assets/img/alejandrogriglio.jpeg"
import bettini from "../assets/img/jorgebettini.jpeg"
import terragnolo from "../assets/img/Terragnolo.jpeg"
import depedro from "../assets/img/depedro.jpeg"
import kornsusky from "../assets/img/kornsusky.jpeg"
import dosso from "../assets/img/dosso.jpeg"

import Cards from './Cards.vue'
import { config } from '@/config'

export default {
  components: { Cards },
  name: 'Welcome',
  computed: {
    contactInfo() {
      return config.CONTACT
    }
  },
  data: function () {
    return {
      image1: revelant,
      image2: prada,
      image5: damico,
      image6: herrero,
      image7: argumedo,
      image8: merli,
      image9: valdemoros,
      image10: moris,
      //image11: colinas,
      image13: tupone,
      image16: griglio,
      image19: bettini,
      image21: terragnolo,
      image22: depedro,
      image23: kornsusky,
      image24: dosso,
      featuredServices: [
        {
          title: 'Clínica Médica',
          description: 'Atención integral y preventiva de la salud',
          icon: 'mdi-stethoscope',
          color: 'blue'
        },
        {
          title: 'Cardiología',
          description: 'Diagnóstico y tratamiento de enfermedades del corazón',
          icon: 'mdi-heart',
          color: 'red'
        },
        {
          title: 'Ginecología y Obstetricia',
          description: 'Atención integral de la salud femenina',
          icon: 'mdi-human-female',
          color: 'pink'
        },
        {
          title: 'Neurología y Neurocirugía',
          description: 'Especialistas en cerebro, columna y sistema nervioso',
          icon: 'mdi-brain',
          color: 'purple'
        },
        {
          title: 'Cirugía General',
          description: 'Intervenciones quirúrgicas convencionales y laparoscópicas',
          icon: 'mdi-hospital-box',
          color: 'indigo'
        },
        {
          title: 'Cirugía Plástica',
          description: 'Procedimientos estéticos y reconstructivos',
          icon: 'mdi-face-woman-shimmer',
          color: 'teal'
        },
        {
          title: 'Dermatología',
          description: 'Cuidado de la piel y tratamientos estéticos',
          icon: 'mdi-face-woman',
          color: 'orange'
        },
        {
          title: 'Traumatología',
          description: 'Especialistas en huesos, articulaciones y músculos',
          icon: 'mdi-arm-flex',
          color: 'brown'
        },
        {
          title: 'Psiquiatría',
          description: 'Atención de la salud mental y bienestar emocional',
          icon: 'mdi-head-heart',
          color: 'green'
        },
        {
          title: 'Endocrinología y Diabetes',
          description: 'Control de hormonas, metabolismo y diabetes',
          icon: 'mdi-water',
          color: 'cyan'
        },
        {
          title: 'Neumología',
          description: 'Enfermedades respiratorias y estudios del sueño',
          icon: 'mdi-weather-windy',
          color: 'light-blue'
        },
        {
          title: 'Reumatología',
          description: 'Tratamiento de artritis y enfermedades autoinmunes',
          icon: 'mdi-human-handsup',
          color: 'deep-orange'
        },
        {
          title: 'Nefrología',
          description: 'Cuidado de la salud renal',
          icon: 'mdi-water-pump',
          color: 'blue-grey'
        },
        {
          title: 'Nutrición',
          description: 'Planes de alimentación y control de peso',
          icon: 'mdi-food-apple',
          color: 'light-green'
        },
        {
          title: 'Cirugía Vascular',
          description: 'Tratamiento de patologías arteriales y venosas',
          icon: 'mdi-heart-pulse',
          color: 'red darken-2'
        }
      ]
    }
  },
  methods: {
    redirect() {
      this.$router.replace({ name: "nuevoturno" });
    },
    redirectToAppointment() {
      this.$router.push({ name: "nuevoturno" });
    },
    redirectToAbout() {
      this.$router.push({ name: "about" });
    }
  }
}
</script>

<style scoped>
.hero-section {
  background: linear-gradient(135deg, #8D4E3C 0%, #6D4C41 100%);
  min-height: 500px;
  display: flex;
  align-items: center;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('../assets/banner-home.png') center/cover;
  opacity: 0.1;
}

.hero-section .v-container {
  position: relative;
  z-index: 1;
}

.services-section {
  background-color: #F5F5F5;
}

.service-card {
  border-radius: 16px !important;
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0,0,0,0.15) !important;
  border-color: #8D4E3C;
}

.doctors-section {
  background-color: #ffffff;
}

.quick-info-section {
  background: linear-gradient(45deg, #EFEBE9 0%, #D7CCC8 100%);
}

.v-card {
  border-radius: 12px !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.v-btn {
  border-radius: 25px !important;
  text-transform: none !important;
  font-weight: 600;
  transition: all 0.3s ease;
}

.v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}

.h-100 {
  height: 100%;
}

/* Typography improvements */
.display-1 {
  line-height: 1.2;
}

.headline {
  line-height: 1.4;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .hero-section {
    min-height: 70vh;
  }
  
  .hero-section .display-1 {
    font-size: 2.5rem !important;
  }
  
  .hero-section .headline {
    font-size: 1.5rem !important;
  }
  
  .hero-section .title {
    font-size: 1.2rem !important;
  }
}

@media (max-width: 600px) {
  .hero-section .display-1 {
    font-size: 2rem !important;
  }
  
  .hero-section .headline {
    font-size: 1.3rem !important;
  }
}

/* Animation for sections */
.services-section,
.doctors-section,
.quick-info-section {
  animation: fadeInUp 0.8s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #EFEBE9;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #8D4E3C;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #6D4C41;
}

/* Legacy styles for compatibility */
a {
  color: #8D4E3C;
}

div.home a {
  color: #8D4E3C;
}
</style>
